import { Alert, Button, Glyphicon, Table } from 'react-bootstrap'

import PropTypes from 'prop-types'
import React from 'react'

export class TemplateJsonPanel extends React.Component {
  constructor(props) {
    super(props)
    this.onDownloadLog = this.onDownloadLog.bind(this)
  }

  renderPanel(item, bsStyle) {
    return <Alert bsStyle={bsStyle}>{item.value}</Alert>
  }

  renderImages(item) {
    const resolution = 1024 / item.items.length
    return (
      <Table responsive>
        <tr>
          {item.items.map(value => {
            const src = 'data:image/png;base64,' + value.value
            const ratio = resolution / value.xsize
            return (
              <td key={value.title}>
                <img height={value.ysize * ratio} width={value.xsize * ratio} src={src} alt="" />
                <br />
                <span className="summary_datacollection_parameter">{value.title}</span>
              </td>
            )
          })}
        </tr>
      </Table>
    )
  }

  renderImage(item) {
    const ratio = item.xsize / 1024
    const src = 'data:image/png;base64,' + item.value
    return (
      <div>
        <img height={item.ysize * ratio} width={item.xsize * ratio} src={src} alt="" />
        <br />
        <span className="summary_datacollection_parameter">{item.title}</span>
      </div>
    )
  }

  renderTable(item) {
    return (
      <Table responsive striped bordered condensed hover>
        <th style={{ backgroundColor: '#3892d3', color: 'white', fontSize: '14px' }} colSpan={item.columns.length}>
          {item.title}
        </th>
        <tbody>
          <tr>
            {item.columns.map(value => (
              // FIXME bmo 20210210
              // eslint-disable-next-line react/jsx-key
              <th>{value}</th>
            ))}
          </tr>
          {item.data.map(value => (
            // FIXME bmo 20210210
            // eslint-disable-next-line react/jsx-key
            <tr>
              {value.map(column => (
                // FIXME bmo 20210210
                // eslint-disable-next-line react/jsx-key
                <td>{column}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    )
  }

  onDownloadLog(e) {
    const element = document.createElement('a')
    const file = new Blob([e.target.value], { type: 'text/plain' })
    element.href = URL.createObjectURL(file)
    element.download = 'myFile.txt'
    document.body.appendChild(element)
    element.click()
  }

  renderLogFile(item) {
    return (
      <Button value={item.logText} onClick={this.onDownloadLog}>
        <Glyphicon glyph="download-alt" /> {item.linkText}
      </Button>
    )
  }

  renderItem(item) {
    switch (item.type) {
      case 'title':
        return <h1>{item.value}</h1>
      case 'info':
        return this.renderPanel(item, 'info')
      case 'warning':
        return this.renderPanel(item, 'warning')
      case 'images':
        return this.renderImages(item)
      case 'image':
        return this.renderImage(item)
      case 'table':
        return this.renderTable(item)
      case 'logFile':
        return this.renderLogFile(item)
      default:
        return item.type + ' Not implemented yet'
    }
  }

  render() {
    if (this.props.type === null) {
      return null
    }

    return <div style={{ margin: '50px' }}>{this.props.items.map(value => this.renderItem(value))}</div>
  }
}

TemplateJsonPanel.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  items: PropTypes.array,
}

export default TemplateJsonPanel
